import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { StructuredRecordEditorCareMapDrawer } from './structured-records/StructuredRecordEditorCareMapDrawer';
import { DiagnosisDescriptor } from './DiagnosisDescriptor';
import { DiagnosisFormState } from './DiagnosisFormState';

export type IDiagnosisEditorCareMapDrawerProps = {
    id: string;
};

export const DiagnosisEditorCareMapDrawer: FC<IDiagnosisEditorCareMapDrawerProps> = ({ id }) => {
    const descriptor = useInstance(DiagnosisDescriptor);
    const formState = useInstance(DiagnosisFormState);

    return (
        <StructuredRecordEditorCareMapDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
